import * as React from "react";
import {Text, View} from "react-native";
import {PaymentButton} from "./dashboard/shared/payment-button";
import { Bold } from "../../../shared/bold";
import {TransparentBox} from "../../../ui/transparent-box";

export const Subscribe = ({
    onSubscribe
}) => {

    const Separator = () => <View
        style={{borderColor: '#a0c946', height: 0, borderBottomWidth: 1, marginLeft: 20, marginRight: 20}} />

    return <View style={{padding: 50}}>
        <TransparentBox>
            <View style={{
                flex: 1,
                alignItems: 'center',
                padding: 10,
                paddingTop: 20
            }}>
                <Text style={{fontSize: 35, fontWeight: 'bold', color: '#a0c946'}}>Minimum</Text>
                <Text style={{fontSize: 30, color: 'white' }}>6 months offer</Text>
                <Text style={{fontSize: 35, color: '#a0c946', fontWeight: 'bold', marginTop: 15, marginBottom: 0}}>Rs 1800</Text>
                <Text style={{ marginBottom: 10, marginTop: 5, color: 'white' }}>Only <Text style={{color: '#a0c946' }}>Rs
                    300</Text> monthly !</Text>
            </View>
            <Separator/>
            <View style={{padding: 20, alignItems: 'center'}}>
                <Text style={{color: 'white', textAlign: 'center'}}>120L wheelie bin included</Text>
            </View>
            <Separator/>
            <View style={{padding: 20, alignItems: 'center'}}>
                <Text style={{color: 'white', textAlign: 'center'}}>2 free pick up monthly included</Text>
                <Text style={{color: '#9cb5b3'}}>(when required)</Text>
            </View>
        </TransparentBox>

        <View style={{marginTop: 10}}>
            <PaymentButton product="subscribe" onPay={onSubscribe}>Subscribe Now</PaymentButton>
        </View>
    </View>
}